<template>
  <div class="clara-footer p-4">
    <div class="is-flex-centered is-full-width has-gap-8">
      <div class="clara-footer-input-box is-flex-centered p-3 is-radius-medium">
        <input
          ref="input"
          v-model="message"
          type="text"
          class="clara-footer-input is-full-width is-borderless is-size-4 has-line-height-24 has-text-black"
          :data-e2e="AICypressAttribute.inputs.CLARA_FOR_PLANNERS_MESSAGE"
          :placeholder="$t('ai.clara-for-planners.message-placeholder')"
          :disabled="disabled"
          @keyup.enter="onSubmit"
        />
      </div>

      <ButtonView
        :type="canSubmit ? 'is-primary' : ''"
        :disabled="!canSubmit"
        :data-e2e="AICypressAttribute.buttons.CLARA_FOR_PLANNERS_SEND"
        @click="onSubmit"
      >
        {{ $t('ai.clara-for-planners.send') }}
      </ButtonView>
    </div>

    <p class="is-size-6 has-text-grey has-text-centered">
      {{ $t('ai.clara-for-planners.disclaimer') }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';

export default defineComponent({
  name: 'ClaraForPlannersFooter',
  emits: ['submit'],
  components: {
    ButtonView
  },
  props: {
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  static: {
    AICypressAttribute
  },
  data(): {
    message: string;
  } {
    return {
      message: ''
    };
  },
  computed: {
    canSubmit(): boolean {
      return !this.disabled && this.message.trim().length > 0;
    }
  },
  methods: {
    onSubmit(): void {
      if (!this.canSubmit) {
        return;
      }
      this.$emit('submit', this.message.trim());
      this.message = '';
    }
  }
});
</script>

<style scoped>
.clara-footer {
  border-top: var(--ce-1px) solid var(--ce-white-bis);
}

.clara-footer-input-box {
  flex: 1 0 0;
  border: var(--ce-1px) solid var(--ce-secondary-bg-color);
}

.clara-footer-input-box:focus-within {
  border-color: var(--ce-primary);
}

.clara-footer-input {
  outline: none;
}
</style>
